module.exports = __webpack_public_path__ + "img/headshot-contact.d65d3f67.jpg";